const React = require('react');
const createReactClass = require('create-react-class');
const Section = require("../../../components/global/components/Section");
const _ = require('lodash');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const Column = Form.Column;
const Row = Form.Row;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Modal = FuzzyReaction.Components.Global.Modal;
const Button = FuzzyReaction.Components.Global.Button;
const RequirePermissions = FuzzyReaction.Components.Authentication.RequirePermissions;
const CmsUserStore = FuzzyReaction.Stores.CmsUserStore;
const FormStore = FuzzyReaction.Stores.FormStore;
const Label = require("../../../components/global/components/Label");

const CastActions = require('../../../actions/CastManagementActions');
const CastStore = require('../../../stores/CastStore');
const InstructorsStore = require('../../../stores/InstructorsStore');
const FormatModalitiesStore = require('../../../stores/FormatModalitiesStore');
const CastPreview = require('./CastPreview');

const CastManagement = createReactClass({
    displayName: 'CastManagement',

    getInitialState: function () {
        return {
            cast: {},
            instructors: [],
            formatModalities: [],
            openAddRecordingModal: false,
            castIsValidLength: true,
            recordingsAreValidLength: true,
            openPreviewModal: false,
            isFormValid: true
        }
    },

    resourceActions: new ResourceActions('casts'),

    /**
     * Cast Management form key
     */
    formKey: 'castManagement',

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            include: ['tracks'],
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    /**
     * Resource action options
     */
    sendOptions: {
        modifiers: {
            include: ['tracks'],
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    /**
     * Resource action options for retrieval of instructors
     */
    instructorResourceOptions: {
        modifiers: {
            sort: {
                name: 'asc'
            },
            pagination: {
                per_page: '20'
            },
            other: {
                raw: true,
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    /**
     * Resource action options for retrieval of formatModalities
     */
    formatModalityResourceOptions: {
        modifiers: {
            include: ['format', 'modality'],
        },
        dataNode: 'data'
    },

    /**
     * Set up time duration options
     */
    timeDurationOptions: [
        {
            label: '5 min',
            value: 300
        },
        {
            label: '10 min',
            value: 600
        },
        {
            label: '20 min',
            value: 1200
        },
        {
            label: '30 min',
            value: 1800
        },
        {
            label: '45 min',
            value: 2700
        },
        {
            label: '60 min',
            value: 3600
        }
    ],

    /**
     * Handle a fired action
     *
     * @param action
     */
    handleAction: function (action) {
        switch (action) {
            case 'next':
                // save to cast store
                CastActions.storeCast(this.state.cast);
                this.props.history.push(`/cast-library/cast-tracks/${typeof this.state.cast.id === 'undefined' ? '' : this.state.cast.id}`);
                break;
            case 'preview':
                this.setState({
                    openPreviewModal: true
                });
                break;
            case 'save':
                this.performOperation();
                break;
        }
    },

    /**
     * Determine the appropriate resource operation and build cast data
     *
     * @return void
     */
    performOperation: function () {
        const cast = _.cloneDeep(this.state.cast);

        // Unset the format_modality object, as we will set the ID instead.
        delete cast.format_modality;

        // Don't try to save an empty set of casts
        if (typeof cast.tracks !== 'undefined' && cast.tracks.length === 0) {
            delete cast.tracks;
        }

        if (typeof this.state.cast.id === 'undefined') {
            this.resourceActions.createResource(cast, this.sendOptions);
        } else {
            this.resourceActions.updateResource(cast, this.sendOptions);
        }
    },

    /**
     * Request cast, if editing a cast
     *
     * @param id
     */
    requestCast: function (id) {
        this.resourceActions.getResource(id, this.getOptions);
    },

    /**
     * Fire request action for instructors
     */
    requestInstructors: function () {
        const instructors = new ResourceActions('instructors');
        instructors.listResource(this.instructorResourceOptions);
    },

    /**
     * Fire request action for formats
     */
    requestFormatModalities: function () {
        const formatModalities = new ResourceActions('format-modalities');
        formatModalities.listResource(this.formatModalityResourceOptions);
    },

    /**
     * Register event listeners and fire requests for data
     */
    componentDidMount: function () {
        const params = this.props.match.params || {};

        this.setState({
            params: params,
            resourceOperation: typeof params.id === 'undefined' ? 'create' : 'edit'
        }, function () {
            // An existing cast
            if (this.state.resourceOperation === 'edit') {
                this.requestCast(params.id);
            }

            this.requestInstructors();
            this.requestFormatModalities();
        });

        CastStore.addChangeListener(this._onRelatedChange);
        InstructorsStore.addChangeListener(this._onInstructorStoreChange);
        FormatModalitiesStore.addChangeListener(this._onRelatedChange);
        FormStore.addChangeListener(this.bindResource);
    },

    /**
     * Deregister event listeners
     */
    componentWillUnmount: function () {
        CastStore.removeChangeListener(this._onRelatedChange);
        InstructorsStore.removeChangeListener(this._onInstructorStoreChange);
        FormatModalitiesStore.removeChangeListener(this._onRelatedChange);
        FormStore.removeChangeListener(this.bindResource);
    },

    _onInstructorStoreChange: function () {
        this.setState({
            instructors: InstructorsStore.getResourceListData(),
        });
    },

    /**
     * Handle change events
     *
     * @private
     */
    _onRelatedChange: function () {
        this.setState({
            cast: CastStore.getResource(),
            formatModalities: FormatModalitiesStore.getResourceListData(),
        }, function () {
            // If this is a new cast, default to the Beats Ride modality
            const castForm = FormStore.getResource(this.formKey);

            let formatModality;
            if (typeof this.state.cast.id === 'undefined') {
                // Find the cycling modality.
                formatModality = this.state.formatModalities.find(formatModality => formatModality.label === 'Beats Ride');
                // Make sure we found something...
                if (formatModality) {
                    // Set the form's modality to cycling.
                    castForm.format_modality = formatModality;
                    castForm.format_modality_id = formatModality.id;

                    // Set the cast to default to "deleted" a.k.a. deactivated; this prevents it from showing up as published.
                    castForm.deleted_at = new Date();
                    this.setState({
                        cast: castForm,
                        isFormValid: FormStore.isFormValid(this.formKey)
                    });
                }
            } else {
                // Find the format/modality matching the cast's format_modality_id.
                formatModality = this.state.formatModalities.find(formatModality => this.state.cast.format_modality_id === formatModality.id);
            }
        });
    },

    /**
     * Gets the selected modality.
     */
    formatModalityAfterChangeCallback: function () {
        const castForm = FormStore.getResource(this.formKey);

        this.setState({
            cast: castForm,
            isFormValid: FormStore.isFormValid(this.formKey)
        });
    },

    isActivatedCheckboxHandler: function (event) {
        const castForm = FormStore.getResource(this.formKey);
        if (event.target.checked) {
            castForm.deleted_at = null;
        } else {
            castForm.deleted_at = new Date();
        }
        this.setState({
            cast: castForm,
            isFormValid: FormStore.isFormValid(this.formKey)
        });
    },

    /**
     * Bind the cast form resource
     */
    bindResource: function () {
        const resource = FormStore.getResource(this.formKey);
        // Default to this user, if this user is an instructor
        if (!resource.instructor_id) {
            const myId = CmsUserStore.me().id;
            const instructorIds = _.map(this.state.instructors, 'id');

            // I am an instructor
            if (instructorIds.indexOf(myId) > 0) {
                resource.instructor_id = CmsUserStore.me().id;
            }
        }

        this.setState({
            cast: resource,
            isFormValid: FormStore.isFormValid(this.formKey)
        });
    },

    /**
     * Build an array of instructor options for the select box
     *
     * @returns {Array}
     */
    instructorOptions: function () {
        const instructors = this.state.instructors;
        const options = [{
            label: 'Select an instructor',
            value: ''
        }];

        return options.concat(instructors.map(function (instructor) {
            return {
                label: instructor.name,
                value: instructor.id
            }
        }));
    },

    /**
     * Build an array of modality options for the select box
     *
     * @returns {Array}
     */
    formatModalityOptions: function () {
        const formatModalities = this.state.formatModalities;
        const options = [{
            label: 'Select a format-modality',
            value: ''
        }];

        return options.concat(formatModalities.map(function (formatModality) {
            return {
                label: formatModality.label,
                value: formatModality.id
            }
        }));
    },

    /**
     * Handle modal close
     */
    closeModal: function () {
        this.setState({
            openPreviewModal: false
        });
    },

    intensityOptions: [
        {
            label: 'Low',
            value: 0
        },
        {
            label: 'Medium',
            value: 1
        },
        {
            label: 'High',
            value: 2
        }
    ],

    /**
     * Set up table keys
     */
    recordingTableKeys: {
        'Recording Title': 'title',
        'Music Track': 'track',
        'Voice Track': 'duration',
        'Total Recording Time': 'track'
    },

    /**
     * Disable next part of flow
     *
     * @returns {boolean}
     * @private
     */
    _disableSaveNext: function () {
        const cast = this.state.cast;
        return !this.state.isFormValid
            || !cast.content_id
            || !cast.instructor_id
            || !cast.format_modality_id
            || typeof cast.target_duration === 'undefined' || cast.target_duration === null
            || typeof cast.average_speed === 'undefined' || cast.average_speed === null
            || typeof cast.title === 'undefined' || cast.title === null;
    },

    _castInstructor: function () {
        if (this.state.instructors.length === 0 || typeof this.state.cast.instructor_id === 'undefined' || !this.state.cast.instructor_id) {
            return 'Instructor';
        }

        return _.filter(this.state.instructors, {id: Number(this.state.cast.instructor_id)})[0].name;
    },

    _castModality: function () {
        if (this.state.formatModalities.length === 0 || typeof this.state.cast.format_modality_id === 'undefined' || !this.state.cast.format_modality_id) {
            return 'Format-Modality';
        }

        return _.filter(this.state.formatModalities, {id: Number(this.state.cast.format_modality_id)})[0].modality.label;
    },

    _castFormat: function () {
        if (this.state.formatModalities.length === 0 || typeof this.state.cast.format_modality_id === 'undefined' || !this.state.cast.format_modality_id) {
            return 'Format';
        }

        return _.filter(this.state.formatModalities, {id: Number(this.state.cast.format_modality_id)})[0].format.label;
    },

    render: function () {
        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="6">
                            <h1 className="page-header">Manage Cast</h1>
                        </Column>
                    </Row>
                    <Column grid="lg" size="10" classes="offset-lg-1">
                        <div className="card card-default">
                            <div className="card-body">
                                <Row>
                                    <Column grid="lg" size="12">
                                        <div className="card card-default cast-management-sections">
                                            <Form key={"castManagement" + this.state.cast.id} formKey={this.formKey}
                                                  bindResource={this.state.cast}>
                                                <Row>
                                                    <Column grid="lg" size="12">
                                                        <Section title="Cast Details" defaultSection>
                                                            <Row>
                                                                <Column grid="lg" size="6">
                                                                    <RequirePermissions requiredPermissions={['admin']}>
                                                                        <Form.SelectBox fieldKey="instructor_id"
                                                                                        label="Instructor"
                                                                                        options={this.instructorOptions()}
                                                                                        bindResource={this.state.cast}/>
                                                                    </RequirePermissions>

                                                                    <Form.SelectBox fieldKey="format_modality_id"
                                                                                    label="Format-Modality"
                                                                                    options={this.formatModalityOptions()}
                                                                                    bindResource={this.state.cast}
                                                                                    afterChangeCallback={this.formatModalityAfterChangeCallback}/>

                                                                    <Form.RadioButtons fieldKey="target_duration"
                                                                                       label="Length"
                                                                                       options={this.timeDurationOptions}
                                                                                       requried/>

                                                                    <Form.Input fieldKey="content_id" type="text"
                                                                                label="Content ID"
                                                                                placeholder="a.k.a Workout ID"
                                                                                limit={30}
                                                                                validations="isLength:16:30"
                                                                                required={true}/>
                                                                </Column>

                                                                <Column grid="lg" size="6">
                                                                    <Form.Input fieldKey="title" type="text"
                                                                                label="Title"
                                                                                placeholder="Cast Title" limit={120}
                                                                                validations="isLength:4:120"
                                                                                required={true}/>

                                                                    <Form.TextArea fieldKey="description"
                                                                                   label="Description"
                                                                                   placeholder="Enter a cast description..."
                                                                                   limit={150}
                                                                                   validations="isLength:0:150"
                                                                                   rows="2"/>

                                                                    <Form.Input fieldKey="average_speed" type="text"
                                                                                label="Average Speed"
                                                                                placeholder="Average Speed (MPH)"
                                                                                limit={120}
                                                                                validations="isFloat" required={true}/>

                                                                    <Form.SelectBox fieldKey="intensity"
                                                                                    label="Intensity"
                                                                                    options={this.intensityOptions}/>

                                                                    <div className={'form-group'}>
                                                                        <Label title={'Activation'}/>
                                                                        <div className={'form-control'}>
                                                                            <div className={'checkbox'}>
                                                                                <label>
                                                                                    <input name='isActivated'
                                                                                           value={this.state.cast.deleted_at || ''}
                                                                                           defaultChecked={this.state.cast.deleted_at === null}
                                                                                           type="checkbox"
                                                                                           onChange={this.isActivatedCheckboxHandler}/>
                                                                                    <span className="checkbox-material">
                                                                                    <span className="check"/>
                                                                            </span>
                                                                                    <Label
                                                                                        overrideClass="checkbox-label"
                                                                                        title="Is Activated"
                                                                                        suppressNewline={true}/>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Column>
                                                            </Row>
                                                        </Section>
                                                    </Column>
                                                </Row>
                                            </Form>
                                            <Row classes="justify-content-end">
                                                <Button action="preview" text="Preview"
                                                        handleAction={this.handleAction}/>
                                                <Button action="save" disabled={this._disableSaveNext()}
                                                        text="Save Changes" handleAction={this.handleAction}
                                                        mods={['success']}/>
                                                <Button action="next" disabled={this._disableSaveNext()}
                                                        text="Add Music and Voice Tracks"
                                                        handleAction={this.handleAction}
                                                        mods={['primary']}/>
                                            </Row>
                                        </div>
                                    </Column>
                                </Row>
                            </div>
                        </div>
                    </Column>
                </div>

                {this.state.openPreviewModal &&
                    <Modal openWhen={this.state.openPreviewModal}
                           title="Preview Cast" closeText="Continue Editing"
                           saveText="Save For Later" afterClose={this.closeModal}
                           beforeSave={this.performOperation}
                           afterSave={this.closeModal}
                           modalBodyClasses="cast-preview-modal">
                        <CastPreview key={'cast:' + this.state.cast.id}
                                     cast={this.state.cast}
                                     instructor={this._castInstructor()}
                                     modality={this._castModality()}
                                     format={this._castFormat()}/>
                    </Modal>
                }
            </div>
        )
    },
});

module.exports = CastManagement;
